






















import { defineComponent, PropType, ref } from '~/utils/nuxt3-migration'
import { defineComponentTranslations } from '~/utils/i18n'
import { AuditRequest } from '~/models/audit/request'
import { useI18n } from '~/compositions/i18n'
import { useSnackbar } from '~/compositions/snackbar'
import { useLogger } from '~/compositions/logger'
import { useDep } from '~/compositions/dependency-container'
import AuditRequestService from '~/services/audits/AuditRequestService'
import CInfoModal from '~/components/shared/configurable/info/CInfoModal.vue'

export default defineComponent({
  components: { CInfoModal },
  props: {
    auditRequest: {
      type: Object as PropType<AuditRequest>,
      required: true
    }
  },
  setup() {
    const { t } = useI18n()
    const snackbar = useSnackbar()
    const logger = useLogger()

    const auditRequestService = useDep(AuditRequestService)

    const loading = ref(false)

    async function onShownToggleChange(
      requestId: AuditRequest['id'],
      isShown: boolean
    ) {
      loading.value = true

      try {
        if (isShown) {
          await auditRequestService.showOnClassified(requestId)
          snackbar.success(t('audit_request_shown_on_classified'))
        } else {
          await auditRequestService.hideFromClassified(requestId)
          snackbar.success(t('audit_request_hidden_from_classified'))
        }
      } catch (err) {
        logger.captureError(`Failed to toggle audit request visibility`, err)
        snackbar.error(err.response?.data?.error || t('something went wrong'))
      } finally {
        loading.value = false
      }
    }

    return {
      onShownToggleChange,
      loading
    }
  },
  i18n: defineComponentTranslations({
    shown_in_classified: {
      en: 'Show in classified',
      el: 'Εμφάνιση στην αγγελία'
    },
    shown_in_classified_info_title: {
      en: 'Show in classified',
      el: 'Εμφάνιση πιστοποιητικού στην αγγελία'
    },
    shown_in_classified_info_body: {
      en:
        'Disable this option if you do not want the certificate to be displayed to all the visitors of your classified.',
      el:
        'Απενεργοποίησε αυτή την επιλογή εάν δεν θέλεις να εμφανίζεται το πιστοποιητικό σε όλους τους επισκέπτες της αγγελίας σου'
    },
    audit_request_shown_on_classified: {
      en: 'Audit request shown on classified',
      el: 'Το αίτημα ελέγχου εμφανίστηκε στην αγγελία'
    },
    audit_request_hidden_from_classified: {
      en: 'Audit request hidden from classified',
      el: 'Το αίτημα ελέγχου κρύφτηκε από την αγγελία'
    }
  })
})
